import React from 'react';
import { Link } from 'react-router-dom';
import {ArrowTopRightOnSquareIcon} from "@heroicons/react/24/solid";

const Footer = () => {
    return (
        <footer className="bg-gray-800 text-gray-300 mt-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3">
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">

                    {/* Branding & Creator Section */}
                    <div className="col-span-1 lg:col-span-2">
                        <h3 className="text-2xl font-bold text-white">QA Learning Hub</h3>
                        <p className="mt-2 text-gray-400">Your journey to becoming a QA expert starts here.</p>
                        <p className="mt-4 text-sm text-gray-500">
                            Created by <a> <Link to="https://www.techmaster.agency/"  className="font-semibold text-indigo-400">TechMasters </Link> </a>

                        </p>
                    </div>

                    {/* Sitemap Section */}
                    <div>
                        <h4 className="font-semibold text-white tracking-wider uppercase">Sitemap</h4>
                        <ul className="mt-4 space-y-2">
                            <li><Link to="/" className="hover:text-indigo-400 transition-colors">Home</Link></li>
                            <li><Link to="/getting-started" className="hover:text-indigo-400 transition-colors">Get Started</Link></li>
                            <li><Link to="/tutorials" className="hover:text-indigo-400 transition-colors">Tutorials</Link></li>
                            <li><Link to="/tools" className="hover:text-indigo-400 transition-colors">Tools</Link></li>
                        </ul>
                    </div>

                    {/* Follow Us Section */}
                </div>
                {/* --- NEW: Support Us Section with PayPal --- */}
                <div>
                    <h4 className="font-semibold text-white tracking-wider uppercase">Support Us</h4>
                    <p className="mt-4 text-sm text-gray-400">If this site is helpful, consider showing your support!</p>
                    <div className="mt-4">
                        {/* Replace with your actual PayPal.Me link */}
                        <a
                            href="https://paypal.me/TalalRKh?country.x=JO&locale.x=en_US"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-x-2 rounded-md bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                            Support with PayPal
                            <ArrowTopRightOnSquareIcon className="w-4 h-4" />
                        </a>
                    </div>
                </div>
                {/* Bottom Bar */}
                <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-500">
                    <p>&copy; {new Date().getFullYear()} QA Learning Hub. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;